/**
 * How a bank account is named to a human, in the browser.
 *
 * The API is the authority: CRMPartnerBankingDetails.display_label (crm/models.py)
 * builds the same string server-side and every banking payload ships it. This helper
 * exists so an older payload, or one that predates that field, still renders
 * bank-name-first instead of leading with the account owner -- which is the entity's
 * own name on nearly every row, and was the reason the picker read the same string
 * five times over.
 */
export function bankAccountLabel(bank) {
  if (!bank) return '';
  if (bank.display_label) return bank.display_label;

  const parts = [
    (bank.bank_name || '').trim() || '(Bank name missing)',
    (bank.bank_account_number || bank.iban_number || '').trim(),
    (bank.account_owner_name || '').trim(),
  ];
  return parts.filter(Boolean).join(' - ');
}

export default bankAccountLabel;
